import React, { useMemo, useRef, useState } from 'react';
import { useOnClickOutside } from '../../../hooks/useOnClickOutside';
import * as S from './styles';
const CountryPicker = ({ markets, direction = 'up', align = 'left', locale = 'other', onSelect, inHeader, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const activeMarket = useMemo(() => Object.values(markets).find((market) => market.locale === locale) ||
        Object.values(markets).find((market) => market.locale === 'other'), [markets, locale]);
    const closeDropdown = () => {
        setIsOpen(false);
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    useOnClickOutside(ref, closeDropdown);
    return (React.createElement(S.ToggleWrapper, { ref: ref, inHeader: inHeader },
        React.createElement(S.CountryToggle, { onClick: toggleDropdown },
            (activeMarket === null || activeMarket === void 0 ? void 0 : activeMarket.flag) && React.createElement(S.FlagWrapper, null, activeMarket.flag),
            React.createElement(S.CountryName, null, activeMarket === null || activeMarket === void 0 ? void 0 : activeMarket.country),
            React.createElement(S.StyledArrowDropDownRoundedIcon, { isOpen: isOpen, direction: direction })),
        React.createElement(S.CountryPickerDropDown, { isOpen: isOpen, direction: direction, align: align, inHeader: inHeader }, Object.values(markets).map((market) => (React.createElement(S.CountryCard, { href: market.link, key: `countrySelector_${market.locale}`, "data-preferred-locale": market.preferredLocale, onClick: onSelect, "$isActive": (activeMarket === null || activeMarket === void 0 ? void 0 : activeMarket.country) === market.country },
            React.createElement(S.FlagWrapper, null, market.flag),
            market.country))))));
};
export default CountryPicker;
//# sourceMappingURL=index.js.map